export var TradeInIntegrationType;
(function (TradeInIntegrationType) {
    TradeInIntegrationType["NONE"] = "none";
    TradeInIntegrationType["STAND_ALONE"] = "standAlone";
    TradeInIntegrationType["FULL"] = "full";
})(TradeInIntegrationType || (TradeInIntegrationType = {}));
//# sourceMappingURL=tradeInIntegrationType.js.map